const TABS = {
  CAMPAIGNS: 'Campaigns',
  TEMPLATES: 'Configuration Drafts'
};

const labels = [TABS.CAMPAIGNS, TABS.TEMPLATES];

export { TABS, labels };
